<!-- 论文归档 -->
<template>
  <svg
    t="1748247519846"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="63555"
    width="200"
    height="200"
  >
    <path
      d="M0 1024V576L171.008 0l681.6 3.2L1024 576v448H0zM779.424 105.6H244.544L104.992 576H192l128 96h384l128-96h86.944zM928 672h-64l-102.4 76.8-25.6 19.2H288l-25.6-19.2L160 672H96v256h832v-256z m-608-288h128V192h128v192h128l-192 192z"
      fill="#0590DF"
      p-id="63556"
    />
  </svg>
</template>
